// import { useEffect, useState } from "react";
// import api from "../api/axios";

// function DisplayBoard() {
//   const [tokens, setTokens] = useState([]);

//   useEffect(() => {
//     loadPendingTokens();

//     const interval = setInterval(() => {
//       loadPendingTokens();
//     }, 5000); // every 5 sec

//     return () => clearInterval(interval);
//   }, []);

//   const loadPendingTokens = async () => {
//     try {
//       const response = await api.get("/Token/pending");
//       setTokens(response.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
    
//     <div>
//   <h1>Pending Tokens</h1>

//   {tokens.map((item) => (
//     <div
//       key={item.id}
//       style={{
//         fontSize: "40px",
//         fontWeight: "bold",
//         margin: "10px"
//       }}
//     >
//       {item.tokenNo}
//     </div>
//   ))}

//       <h2>Pending Tokens</h2>

//       <table border="1" cellPadding="10">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Token No</th>
//             <th>Customer Name</th>
//             <th>Mobile No</th>
//             <th>ServiceId</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tokens.map((item) => (
//             <tr key={item.id}>
//                <td>{item.id}</td>
//               <td>{item.tokenNo}</td>
//               <td>{item.customerName}</td>
//               <td>{item.mobileNo}</td>
//                <td>{item.ServiceId}</td>
//               <td>{item.status}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default DisplayBoard;


// import { useEffect, useState } from "react";
// import api from "../api/axios";

// function DisplayBoard() {

//   const [current, setCurrent] = useState(null);
//   const [queue, setQueue] = useState([]);

//   const loadData = async () => {
//     const currentRes = await api.get("/Token/current");
//     const queueRes = await api.get("/Token/queue");

//     setCurrent(currentRes.data);
//     setQueue(queueRes.data);
//   };

//   useEffect(() => {
//     loadData();

//     const interval = setInterval(loadData, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div>
     
//       <h1>Now Serving</h1>

//       {current && (
//         <>
//           <h1>{current.tokenNo}</h1>
//           <h2>Counter {current.counterId}</h2>
//         </>
//       )}

//       <hr />

//       <h2>Waiting Queue</h2>

//       {queue.map((t, i) => (
//         <div key={i}>{t.tokenNo}</div>
//       ))}
//     </div>
//   );
// }

// export default DisplayBoard;

// without sound

// import { useEffect, useState } from "react";
// import api from "../api/axios";

// function DisplayBoard() {

//   const [current, setCurrent] = useState(null);
//   const [queue, setQueue] = useState([]);

//   const loadData = async () => {

//     try {

//       const currentRes =
//         await api.get("/Token/current");

//       const queueRes =
//         await api.get("/Token/queue");

//       setCurrent(currentRes.data);
//       setQueue(queueRes.data);

//     }
//     catch (error) {

//       console.log(error);

//     }
//   };

//   useEffect(() => {

//     loadData();

//     const interval =
//       setInterval(loadData, 3000);

//     return () => clearInterval(interval);

//   }, []);

//   return (

//     <div className="container-fluid p-4">

//       <div className="row">

//         <div className="col-md-8">

//           <div className="card text-center p-5">

//             <h2>Now Serving</h2>

//             {current ? (
//               <>
//                 <h1
//                   style={{
//                     fontSize: "90px"
//                   }}
//                 >
//                   {current.tokenNo}
//                 </h1>

//                 <h3>
//                   Counter :
//                   {current.counterId}
//                 </h3>
//               </>
//             ) : (
//               <h3>No Token Serving</h3>
//             )}

//           </div>

//         </div>

//         <div className="col-md-4">

//           <div className="card p-3">

//             <h3>Waiting Queue</h3>

//             <table className="table">

//               <thead>

//                 <tr>
//                   <th>Token</th>
//                 </tr>

//               </thead>

//               <tbody>

//                 {queue.map((t) => (

//                   <tr key={t.id}>

//                     <td>
//                       {t.tokenNo}
//                     </td>

//                   </tr>

//                 ))}

//               </tbody>

//             </table>

//           </div>

//         </div>

//       </div>

//     </div>

//   );
// }

// export default DisplayBoard;

import { useEffect, useRef, useState } from "react";
import api from "../api/axios";

function DisplayBoard() {

  const [current, setCurrent] = useState(null);
  const [queue, setQueue] = useState([]);

  const lastToken = useRef("");

  const loadData = async () => {

    try {

      const currentRes =
        await api.get("/Token/current");

      const queueRes =
        await api.get("/Token/queue");

      console.log("Current Token:", currentRes.data);

      setCurrent(currentRes.data);
      setQueue(queueRes.data);

    }
    catch (error) {

      console.log(error);

    }
  };

  useEffect(() => {

    loadData();

    const interval =
      setInterval(loadData, 3000);

    return () => clearInterval(interval);

  }, []);

  // Voice Announcement
  // useEffect(() => {

  //   if (!current?.tokenNo)
  //     return;

  //   const tokenKey =
  //     `${current.tokenNo}-${current.counterId}`;

  //   // Same token repeat na ho
  //   if (lastToken.current === tokenKey)
  //     return;

  //   lastToken.current = tokenKey;

  //   setTimeout(() => {

  //     window.speechSynthesis.cancel();

  //     const speech =
  //       new SpeechSynthesisUtterance(
  //         `Token Number ${current.tokenNo}.
  //          Please proceed to Counter Number ${current.counterId}`
  //       );

  //     speech.lang = "en-IN";
  //     speech.volume = 1;
  //     speech.rate = 0.9;
  //     speech.pitch = 1;

  //     window.speechSynthesis.speak(speech);

  //     console.log(
  //       "Speaking:",
  //       current.tokenNo,
  //       current.counterId
  //     );

  //   }, 500);

  // }, [current?.tokenNo, current?.counterId]);

  useEffect(() => {

  if (!current?.tokenNo)
    return;

  const tokenKey =
    `${current.tokenNo}-${current.counterId}-${current.customerName}`;

  if (lastToken.current === tokenKey)
    return;

  lastToken.current = tokenKey;

  setTimeout(() => {

    window.speechSynthesis.cancel();

    const speech =
      new SpeechSynthesisUtterance(
         `ध्यान दें, ${current.customerName} जो तेलपा से आई है वो ।
        टोकन नंबर ${current.tokenNo},
         कृपया काउंटर नंबर ${current.counterId}
         पर जाएं।`
      );

    speech.lang = "hi-IN";
    speech.volume = 10;
    speech.rate = 0.8;
    speech.pitch = .9;

    window.speechSynthesis.speak(speech);

  }, 500);

}, [current?.tokenNo, current?.counterId,current?.customerName]);

  return (

    <div className="container-fluid p-4">

      <div className="row">

        <div className="col-md-8">

          <div
            className="card text-center shadow-lg"
            style={{
              minHeight: "400px",
              justifyContent: "center"
            }}
          >

            <h2 className="mb-4">
              NOW SERVING
            </h2>

            {current ? (
              <>
                <h1
                  style={{
                    fontSize: "120px",
                    fontWeight: "bold"
                  }}
                >
                  {current.tokenNo}
                </h1>

                <h2>
                  Counter : {current.counterId}
                </h2>
              </>
            ) : (
              <h2>No Token Serving</h2>
            )}

          </div>

        </div>

        <div className="col-md-4">

          <div className="card shadow-lg">

            <div className="card-header bg-primary text-white">

              {/* <button
                className="btn btn-primary btn-sm mb-2"
                onClick={() => {

                  const speech =
                    new SpeechSynthesisUtterance(
                      "Voice Test Successful"
                    );

                  speech.lang = "en-US";

                  window.speechSynthesis.speak(
                    speech
                  );

                }}
              >
                Test Voice
              </button> */}

              <h4 className="mb-0 btn btn-primary">
                Waiting Queue
              </h4>

            </div>

            <div className="card-body">

              <table className="table table-bordered">

                <thead>
                  <tr>
                    <th>Token No.</th>
                    <th>Counter No.</th>
                  </tr>
                </thead>

                <tbody>

                  {queue.length > 0 ? (

                    queue.map((t) => (

                      <tr key={t.id}>
                        <td
                          style={{
                            fontSize: "24px",
                            fontWeight: "bold"
                          }}
                        >
                          {t.tokenNo}
                        </td>
                        <td
                          style={{
                            fontSize: "24px",
                            fontWeight: "bold"
                          }}
                        >
                          {t.counterId}
                        </td>
                      </tr>

                    ))

                  ) : (

                    <tr>
                      <td>
                        No Waiting Token
                      </td>
                    </tr>

                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default DisplayBoard;